/**
 * Régua de tempo da trilha, compartilhada pelas duas telas que a mostram: o // ux-neutrality:allow doc-comment
 * console da plataforma (E53.F7) e o módulo do banco (E61.F4). // ux-neutrality:allow doc-comment
 *
 * Mora aqui, e não em `plataforma_admin.ts`, porque aquele arquivo é o cliente // ux-neutrality:allow doc-comment
 * HTTP de `/plataforma/*` — rotas que o banco nunca alcança. Formatação de // ux-neutrality:allow doc-comment
 * data não tem endereço de rota. // ux-neutrality:allow doc-comment
 */

/** Data e hora ISO → texto curto pt-BR — a trilha precisa da hora. */
export function formatarDataHora(iso: string): string {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return iso;
  return data.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

/**
 * Dia civil do filtro → instante absoluto, no fuso de quem está operando. // ux-neutrality:allow doc-comment
 *
 * A tabela mostra a hora de cada evento no fuso do operador; o recorte tem que // ux-neutrality:allow doc-comment
 * usar a mesma régua, ou "até 27/07" corta num lugar e a tela mostra outro. // ux-neutrality:allow doc-comment
 * `new Date('YYYY-MM-DDTHH:MM:SS')` — sem sufixo de fuso — é lido como hora // ux-neutrality:allow doc-comment
 * local, e `toISOString` fecha o instante com o offset resolvido. Enviar a // ux-neutrality:allow doc-comment
 * string ingênua deixava o servidor decidir o fuso por conta própria // ux-neutrality:allow doc-comment
 * (F-E53.F7-01). // ux-neutrality:allow doc-comment
 */
export function instanteDoDiaLocal(dia: string, borda: 'inicio' | 'fim'): string {
  const hora = borda === 'inicio' ? '00:00:00.000' : '23:59:59.999';
  return new Date(`${dia}T${hora}`).toISOString();
}
